import * as React from 'react'
import PaymentIssueBanner from '@/components/billing/PaymentIssueBanner'
import { Outlet, useLocation } from 'react-router-dom'
import DashboardPage from '@/pages/dashboard/DashboardPage'
import DashboardControlRow from '@/pages/dashboard/DashboardControlRow'
import { useTrackMainView } from '@/hooks/useCloseToOrigin'
import MobileTopBar from '@/mobile/MobileTopBar'
import RouteSheet from '@/mobile/sheets/RouteSheet'
import PhoneTable from '@/mobile/table/PhoneTable'
import TabletTable from '@/mobile/table/TabletTable'
import type { DeviceClass } from '@/mobile/useDeviceClass'

/**
 * Phone / tablet counterpart of LayoutHome, taking the same route flags.
 *
 *   dashboard           → the dashboard, unchanged (it is already adaptive)
 *   home                → the table
 *   modal               → the table, with the route's own dialog on top
 *   modalWithRightPanel → the table, with the transaction list in a sheet
 *   (no flag)           → the table, with the route's window in a sheet
 */
export default function MobileLayoutHome({
  device,
  home = false,
  dashboard = false,
  modal = false,
}: {
  device: Exclude<DeviceClass, 'desktop'>
  home?: boolean
  dashboard?: boolean
  modal?: boolean
  modalWithRightPanel?: boolean
}) {
  useTrackMainView()
  const location = useLocation()
  const showSheet = !dashboard && !home && !modal

  return (
    <div className="pf-mobile flex h-dvh flex-col overflow-hidden bg-layout-secondary">
      <MobileTopBar device={device} dashboard={dashboard} />
      <div className="shrink-0">
        <PaymentIssueBanner />
      </div>

      {dashboard ? (
        <>
          <div className="pf-hscroll flex shrink-0 items-center overflow-x-auto border-b border-primary bg-layout-secondary px-3 py-2">
            <DashboardControlRow />
          </div>
          <div className="min-h-0 flex-1">
            <DashboardPage />
          </div>
        </>
      ) : device === 'phone' ? (
        <PhoneTable />
      ) : (
        <TabletTable />
      )}

      {showSheet && (
        <RouteSheet device={device}>
          <Outlet key={`${location.pathname}-${location.search}`} />
        </RouteSheet>
      )}
      {modal && <Outlet key={`${location.pathname}-${location.search}`} />}
    </div>
  )
}
